// "Most competitive first": highest selectivity score (competitiveness_index) first.
// Rows without a score go last; ties break by lower offer rate, then university, course, id.
const num = (v) => (typeof v === "number" && Number.isFinite(v) ? v : null);

export const competeScore = (r) => num(r?.competitiveness_index);
export const offerRateUsed = (r) => num(r?.subject_offer_rate) ?? num(r?.acceptance_rate_used);

export function compareCompetitive(a, b) {
  const sa = competeScore(a);
  const sb = competeScore(b);
  if (sa == null && sb != null) return 1;
  if (sb == null && sa != null) return -1;
  if (sa != null && sb != null && sa !== sb) return sb - sa;
  const oa = offerRateUsed(a);
  const ob = offerRateUsed(b);
  if (oa == null && ob != null) return 1;
  if (ob == null && oa != null) return -1;
  if (oa != null && ob != null && oa !== ob) return oa - ob;
  const n = (a?.university_name || "").localeCompare(b?.university_name || "");
  if (n) return n;
  const d = (a?.degree_name || "").localeCompare(b?.degree_name || "");
  if (d) return d;
  return String(a?.degree_id || "").localeCompare(String(b?.degree_id || ""));
}

const OFFER_LABEL = {
  subject_offer: "this course's UCAS offer rate",
  ucas_eoc_uni_modelled_offer: "the university-wide offer rate (est.)",
  ucas_eoc_uni: "the university-wide UCAS acceptance rate",
  legacy_uni: "the university-wide acceptance rate",
};

// Plain-English basis for one row's score, e.g. "40% entry tariff + 60% low offer rate (14%, university-wide est.)".
export function competitiveBasis(r) {
  const src = r?.competitiveness_source;
  if (!src || competeScore(r) == null) return null;
  const acc = r?.acceptance_source;
  const rate = offerRateUsed(r);
  const offer = rate != null && OFFER_LABEL[acc]
    ? `how few applicants get in: ${OFFER_LABEL[acc]} of ${Math.round(rate * 100)}%`
    : null;
  if (src === "tariff") return "the course's typical entry tariff (UCAS points) only";
  if (src.startsWith("tariff_and_")) return `40% the course's typical entry tariff (UCAS points) + 60% ${offer}`;
  return offer;
}
